import "./App.css";
import Header from "./Header";
import AppRoutes from "./routes/AuthRoutes";
import Footer from "./components/Footer/Footer";
import toast, { Toaster } from "react-hot-toast";
import { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./components/common/Loader/Loader";
import ConsentBanner from "./components/common/ConsentBanner";

function App() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("blocked") === "true") {
      toast.error("Your account has been blocked by admin.", { duration: 5000 });
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, [location]);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);



  return (
    <div className="App">
      {loading && <Loader />}
      <Header />
      <Suspense fallback={<Loader />}>
        <AppRoutes />
      </Suspense>
      <Footer />
      <ConsentBanner />
      <Toaster position="top-center" reverseOrder={false} />
    </div>
  );
}

export default App;